import React from 'react'
import StyledAdminWrapper from './StyledAdminWrapper'

const UtmBuilder = React.lazy(() => import(/* webpackChunkName: 'admin-utm-builder' */'components_v2/Admin/UtmBuilder'))

const StyledUtmBuilder = ({ ...rest }) => {
  return (
    <StyledAdminWrapper>
      <UtmBuilder />
    </StyledAdminWrapper>
  )
}

export default StyledUtmBuilder
